module.exports = __webpack_public_path__ + "img/c00_buildingtechshieldboss_Normal_ua.002dc948.webp";